import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { SolicitudAnulacionExViewModel, TAnulacionSolicitudExViewModel } from './anulacionEx.types';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { AnulacionExService } from './anulacionEx.service';
import { EnumIdsTwTcTipoClonacion, EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { EnumIdsTcEstadoCertificadoFitoEx, EnumIdsTcEstadoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';

@Component({
    selector: 'app-anulacionex-edit',
    templateUrl: './anulacionEx-edit.component.html',
})
export class AnulacionExEditComponent extends ComponentBase implements OnInit {
    nombreUsuario = '';
    solicitudAnulacionEx: SolicitudAnulacionExViewModel;
    anulacionEx: TAnulacionSolicitudExViewModel;
    idSolicitudEx = 0;
    tituloTipoSolicitudEx: string;
    habilitarGuardar = true;
    esNuevaAnulacion = false;
    visibilitySpinner = false;
    visibilitySpinnerCF = false;
    esClonada = false;
    IdTipoSolicitudEx: number;
    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private solicitudExService: SolicitudExService,
        private navMenuService: NavMenuService,
        private anulacionExService: AnulacionExService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudAnulacionEx = new SolicitudAnulacionExViewModel();
    }

    ngOnInit() {
        this.idSolicitudEx = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitudEx);

        this.createForm();

        if (this.idSolicitudEx) {
            this.loading = true;

            this.anulacionExService.getSolicitudAnulacionEx(this.idSolicitudEx).subscribe(result => {
                this.solicitudAnulacionEx = result;
                this.IdTipoSolicitudEx = this.solicitudAnulacionEx.IdTipoSolicitudEx;
                this.tituloTipoSolicitudEx = this.solicitudAnulacionEx.IdTipoSolicitudExDescripcion;
                this.esClonada =
                    this.solicitudAnulacionEx.TwSolicitudJerarquiaEx !== null &&
                    this.solicitudAnulacionEx.TwSolicitudJerarquiaEx.IdTipoClonacion === EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;
                //SI ES PREVIA
                if (this.solicitudAnulacionEx.EsPrevia) {
                    if (
                        this.solicitudAnulacionEx.IdEstadoSolicitudEx !== EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                        this.solicitudAnulacionEx.IdEstadoSolicitudEx !== EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitudEx += '-Previa';
                    }
                }

                this.esNuevaAnulacion = this.solicitudAnulacionEx.TAnulacionEx === null ? true : false;

                //correo: lo de anular a una solicitud enviada sin que haya sido editada por el inspector lo vamos a tratar como que puede anular directamente en estado nueva
                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.ANULACION_SOLICITUD_EXPORTACION,
                    this.solicitudAnulacionEx.IdEstadoSolicitudEx,
                ).Visible;

                if (!this.esNuevaAnulacion) {
                    this.updateForm();
                } else {
                    this.form.patchValue({
                        IdUsuario: this.loggedInUser!.Id,
                        //NombreInspector: this.loggedInUser!.Nombre + ' ' + this.loggedInUser!.Apellidos,
                    });

                    if (this.habilitarGuardar) {
                        this.form.controls['Observaciones'].enable();
                    }
                }
            });

            this.loading = false;
        }
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            IdUsuario: '',
            NombreUsuario: [{ value: '', disabled: true }],
            Observaciones: [{ value: '', disabled: true }, Validators.required],
            Fecha: [{ value: '', disabled: true }, Validators.required],
            IdAnulacion: [{ value: '', disabled: true }, Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            IdAnulacion: this.solicitudAnulacionEx.TAnulacionEx.Id,
            NombreUsuario: this.solicitudAnulacionEx.TAnulacionEx.NombreUsuario,
            IdUsuario: this.solicitudAnulacionEx.TAnulacionEx.IdUsuario,
            Observaciones: this.solicitudAnulacionEx.TAnulacionEx.Observaciones,
            Fecha: new Date(this.solicitudAnulacionEx.TAnulacionEx.Fecha),
        });
    }

    onCleanObservacion() {
        this.form.patchValue({ Observaciones: '' });
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.navMenuService.currentSolicitudExportacion.Id]);
    }

    enviarAnulacion() {
        //Nueva confirmacion de estado, para impedir anulaciones si ya las ha aceptado el inspector
        this.anulacionExService.getSolicitudAnulacionEx(this.idSolicitudEx).subscribe(result => {
            if (
                this.isSolicitante &&
                result.IdEstadoSolicitudEx !== EnumIdsTcEstadoSolicitudEx.ID_NUEVA &&
                result.IdEstadoSolicitudEx !== EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
            ) {
                this.addInfoMessage('El estado de la solicitud ha cambiado, por favor, vaya al apartado INSPECCIONES');
            } else {
                this.confirmationService.confirm({
                    message: '¿Está seguro de anular la solicitud actual?.\nTenga en cuenta que no podrá deshacer la operación.',
                    accept: () => {
                        this.onSubmit();
                    },
                });
            }
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        //Todo:agaro. 03052022. Vemos si está emitido el CF y si es así, que anule primero el ephyto o el CF
        if (
            this.solicitudAnulacionEx.NumeroCertificado !== null &&
            //ID_ENVIADA_XXXX_EPHYTO se encuentra esperando una respuesta de TRACK en ComprobarEstadosEphyto, mientras tanto no se deja anular
            (this.solicitudAnulacionEx.IdEstadoCertificadoFitoEx === EnumIdsTcEstadoCertificadoFitoEx.ID_ENVIADA_ANULACION_EPHYTO ||
                this.solicitudAnulacionEx.IdEstadoCertificadoFitoEx === EnumIdsTcEstadoCertificadoFitoEx.ID_ENVIADA_ANULACION_SUSTITUCION_EPHYTO ||
                this.solicitudAnulacionEx.IdEstadoCertificadoFitoEx === EnumIdsTcEstadoCertificadoFitoEx.ID_ENVIADA_EPHYTO)
            //@author jlht Error 115195 Solicitudes en estado Ephyto rechazado no se pueden anular.
            //En servidor se enviará, para este caso, primero la anulación del ePhyto por si estuviese en TRACES y, después, la anulación de la solicitud.
            //|| this.solicitudAnulacionEx.IdEstadoCertificadoFitoEx === EnumIdsTcEstadoCertificadoFitoEx.ID_RECHAZADO_EPHYTO)
            //@author jlht Para este estado, Finalizado Conforme, en servidor se comprueba si es Sede o ePhyto y se anula el CF y luego la solicitud.
            //this.solicitudAnulacionEx.IdEstadoCertificadoFitoEx === EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME ||
        ) {
            //this.addErrorMessage('Debe anular primero el certificado fitosanitario');
            this.addErrorMessage('El ePhyto se ha enviado. Debe esperar la respuesta de TRACES.');
            return;
        }

        this.visibilitySpinner = true;

        let anulacionEx = new TAnulacionSolicitudExViewModel();

        //así­ viajan todos los values, da igual si están disable o no los campos
        anulacionEx = this.form.getRawValue();
        anulacionEx.IdSolicitudEx = this.esNuevaAnulacion ? this.idSolicitudEx : this.solicitudAnulacionEx.Id;
        //aunque en servidor se le asigne la fecha del día, al ser campo obligatorio en el modelo hay que darle valor para que no falle
        anulacionEx.Fecha = this.esNuevaAnulacion ? new Date() : this.solicitudAnulacionEx.TAnulacionEx.Fecha;

        if (this.esNuevaAnulacion) {
            this.anulacionExService.createAnulacionEx(anulacionEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Anulación creada correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }
}
